import clsx from 'clsx';
import { Button, ModalPopup, Stack, Title } from 'components';
import { FC, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getFiles, getFilesPreview } from 'store/files/filesActions';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import GenericFileUploadModalContent from 'components/inputField/fileUploadInputField/genericFileUploadModalContent/genericFileUploadModalContent';
import { axiosPrivate } from 'modules/networkTools/networkTools';

import style from './files.module.scss';
import FilesTable from './filesTable';

type Props = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

const uploadFile = async ({ id, data }: { id: string | number; data: any }) => {
  const response = await axiosPrivate.post(`client/${id}/attachments`, data);
  return response;
};

const FilesModal: FC<Props> = ({ open, setOpen }) => {
  const { clientId } = useParams();
  const dispatch = useAppDispatch();
  const [showModal, setShowModal] = useState(false);
  const { filesList } = useAppSelector((state) => state.files);
  const { content, page, size, sorts } = filesList;
  const fileNames = content?.map((file) => `${file.fileName}.${file.fileExtension}`);

  const handleModalClose = () => {
    setOpen(false);
    if (clientId) {
      dispatch(getFilesPreview({ clientId }));
    }
  };

  return (
    <ModalPopup
      open={open}
      customClassInsideContainer={clsx(style.modalWrapper)}
      handleClose={handleModalClose}
    >
      <Stack width="100%" height="80vh">
        <Stack width="100%" flexDirection="row" justifyContent="space-between">
          <Stack
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="16px"
            mb="24px"
            mt="4px"
          >
            <Title text="Files" type="h3" />
          </Stack>
          <Stack flexDirection="row" gap="12px" mr="48px" mt="-5px">
            <Button
              size="small"
              shape="circle"
              handleOnClick={() => setShowModal(true)}
              icon={<span className="material-icons-outlined">add</span>}
              theme="primary"
              customStyleClass={style.iconButtonAdd}
            />
          </Stack>
        </Stack>
        <Stack width="100%" height="93%">
          {showModal && (
            <ModalPopup
              keepMounted={false}
              open={showModal}
              handleClose={() => setShowModal(false)}
              customClassOutsideContainer={style.uploadModal}
              children={
                <GenericFileUploadModalContent
                  onUploadDone={(_fileMetadata: any) =>
                    clientId && dispatch(getFiles({ clientId, page, size, sorts }))
                  }
                  uploadCb={uploadFile}
                  fileNamesToCompare={fileNames}
                  id={clientId}
                />
              }
            />
          )}
          <FilesTable />
        </Stack>
      </Stack>
    </ModalPopup>
  );
};

export default FilesModal;
